var map = {
	"./backups/listagem-backups.module": [
		"./src/app/routes/backups/listagem-backups.module.ts",
		"common",
		"listagem-backups.module"
	],
	"./configuracao/configuracao.module": [
		"./src/app/routes/configuracao/configuracao.module.ts",
		"common",
		"configuracao.module"
	],
	"./consulta-de-log/consulta-de-log.module": [
		"./src/app/routes/consulta-de-log/consulta-de-log.module.ts",
		"consulta-de-log.module"
	],
	"./dashboard/dashboard.module": [
		"./src/app/routes/dashboard/dashboard.module.ts",
		"common",
		"dashboard.module"
	],
	"./empresas/empresas.module": [
		"./src/app/routes/empresas/empresas.module.ts",
		"empresas.module",
		"common"
	],
	"./login/login.module": [
		"./src/app/routes/login/login.module.ts",
		"login.module"
	],
	"./planos/planos.module": [
		"./src/app/routes/planos/planos.module.ts",
		"common",
		"planos.module"
	],
	"./restauracoes/listagem-restauracoes.module": [
		"./src/app/routes/restauracoes/listagem-restauracoes.module.ts",
		"listagem-restauracoes.module"
	],
	"./ultimos-backups/ultimos-backups.module": [
		"./src/app/routes/ultimos-backups/ultimos-backups.module.ts",
		"common",
		"ultimos-backups.module"
	],
	"./usuarios/usuarios.module": [
		"./src/app/routes/usuarios/usuarios.module.ts",
		"common",
		"usuarios.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main